import './style/index.js';

import _Affix from './affix';

export type { AffixProps } from './affix';
export const Affix = _Affix;
export default Affix;

export * from './type';
